<template>
  <!-- 观演人展示 -->
  <div class="watcher_com">
    <div class="ticket_info_way_title ticket_icon shouhuo">
      <img :src="staticAssets.ImgObj.drama_watcher_icon" alt />
      <span>{{TLang('观演人','my')}}</span>
    </div>
    <div class="watcher_list">
      <ul>
        <li v-for="(item, index) in tickets" :key="index">
          <div class="info_wrap">
            <div class="info_index">{{ index + 1 }}</div>
            <div class="info_name">
              <el-popover
                placement="bottom-start"
                width="220"
                style="display:flex"
                trigger="hover"
                popper-class="qr_code_card"
              >
                <a href="javascript:;" class="user_itm_name" slot="reference">
                  {{
                  item.holderName
                  }}
                </a>
                <span class="user_itm_name">{{ item.holderName }}</span>
              </el-popover>
            </div>
            <div class="user_item_line_id"></div>
            <div class="id_card">{{ publicMethod.getExchangeCard(item.holderIdCardNo) }}</div>
            <div class="info_phone">{{ publicMethod.getExchangeTel(item.holderPhone) }}</div>
            <div class="info_ticketType">{{ item.ticketName }}</div>
            <div class="info_seat">
              {{
              item.seatChooseType != 0
              ? !item.seatChooseType
              ? TLang('无座','my')
              : `${TLang('看台','my')}${item.seatStandName},${item.seatFloorName},${item.seatRowName}${item.seatName}`
              : TLang('无座','my')
              }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "drama_watcher",
  data() {
    return {};
  },
  props: ["tickets"]
};
</script>

<style lang="less" scoped>
.user_item_line_id {
  width: 1px;
  height: 20px;
  background: rgba(237, 237, 237, 1);
  margin: 15px 28px 0 0;
  float: left;
  display: inline-block;
}
.watcher_com {
  margin: 24px 0;
}
.ticket_icon {
  line-height: 21px;
}
.ticket_icon img {
  width: 20px;
  height: 20px;
  display: inline-block;
  // vertical-align: middle;
}
.ticket_icon span {
  display: inline-block;
  margin-left: 15px;
  font-size: 16px;
  color: #111111;
  line-height: 21px;
  height: 21px;
}
.info_wrap {
  height: 50px;
  background-color: #fafafa;
  margin-left: 32px;
  // margin-right: 24px;
  margin-top: 16px;
  line-height: 50px;
  font-size: 14px;
  overflow: hidden;
  .clearfix;
}
.info_index {
  width: 20px;
  height: 20px;
  font-size: 12px;
  color: white;
  background-color: #cccccc;
  line-height: 20px;
  text-align: center;
  margin-top: 15px;
  margin-left: 20px;
  margin-right: 30px;
  float: left;
}
.info_name {
  font-size: 14px;
  color: #111111;
  float: left;
  width: 68px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.id_card {
  width: 171px;
  float: left;
  color: #111111;
  font-weight: bold;
}
.info_phone {
  //width: 117px;
  margin: 0 24px;
  float: left;
  color: #111111;
}
.info_ticketType {
  float: left;
  color: #111111;
}
.info_seat {
  float: left;
  margin-left: 24px;
}
</style>
<style lang="less">
.qr_code_card {
  height: 32px;
  font-size: 12px;
  padding: 8px 12px;
  padding-top: 7px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px #ececec;
  span {
    display: inline-block;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
  }
}
</style>
